import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import {
  getAllMarketsByEvent,
  getBookmakerMarketsByEvent,
  addExchangeBet,
  getCurrencyTypeFromToken,
} from '../../store';
import './ExchBookmakerMarketTable.scss';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@material-ui/core';
import { BsData, PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { UserBet } from '../../models/UserBet';
import moment from 'moment';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import {
  BookmakerDTO,
  BookmakerRunnerDTO,
} from '../../models/common/BookmakerDTO';
import { EventDTO } from '../../models/common/EventDTO';
import API from '../../api';
import Modal from '../../components/Modal/Modal';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import { IonIcon } from '@ionic/react';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { TOSS_ODD_VALUE } from '../../constants/CommonConstants';
import { ThousandFormatter } from '../../util/stringUtil';
import { getMarketLangKeyByName } from '../../util/stringUtil';

type StoreProps = {
  eventData: EventDTO;
  bmMData: BookmakerDTO[];
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  langData:any
};

type Props = StoreProps & {
  loggedIn: boolean;
  enableBookmaker: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  exposureMap: any;
};

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

type LimitsType = Map<string, { minStake: number; maxStake: number }>;

const BmMTable: React.FC<Props> = (props) => {
  const {
    eventData,
    bmMData,
    bets,
    openBets,
    addExchangeBet,
    loggedIn,
    enableBookmaker,
    getFormattedMinLimit,
    getFormattedMaxLimit,
    exposureMap,
    langData
  } = props;
  const disabledStatus = ['suspended', 'closed', 'suspended-manually'];
  const [minStake, setMinStake] = useState<number>(500);
  const [maxStake, setMaxStake] = useState<number>(50000);
  const [limits, setLimits] = useState<LimitsType>();
  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const tableFields = [
    {
      key: 'teamName',
      Label: 'Market',
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'Back',
      Label: 'Back',
      className: 'odds-cell-head back-odd',
      align: 'center',
    },
    {
      key: 'Lay',
      Label: 'Lay',
      className: 'odds-cell-head lay-odd',
      align: 'center',
    },
  ];

  const getOpenBetsPL = (runner: BookmakerRunnerDTO, marketId: string, marketName: string) => {

    if (exposureMap && exposureMap?.[`${marketId}:${marketName}`]) {
      for (let rn of exposureMap[`${marketId}:${marketName}`]) {
        if (rn.runnerId === runner.runnerId) {
          return rn?.userRisk / cFactor
        }
      }
    }
  };

  const getOpenBetsPLInArray = (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string,
  ) => {
    let pl = getOpenBetsPL(runner, marketId, marketName);
    return pl ? [pl] : [];
  };

  const getTotalPL = (runner: BookmakerRunnerDTO, marketId: string, marketName: string) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) => b.marketId === marketId && b.amount && b.amount > 0
    );
    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(runner, marketId, marketName);
      for (let bet of mBetslipBets) {
        const plVal = (bet.oddValue / 100 + 1) * bet.amount - bet.amount;
        if (bet.betType === 'BACK') {
          if (bet.outcomeId === runner.runnerId)
            returns ? (returns += plVal) : (returns = plVal);
          else returns ? (returns -= bet.amount) : (returns = 0 - bet.amount);
        } else if (bet.betType === 'LAY') {
          if (bet.outcomeId === runner.runnerId)
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          else returns ? (returns += bet.amount) : (returns = bet.amount);
        }
      }
    }
    return [returns];
  };

  // const fetchBetLimits = async () => {
  //   try {
  //     const payload = {
  //       betLimitsType: 'MARKET',
  //       minStake: null,
  //       maxStake: null,
  //       category: 'SPORTS',
  //       sportId: eventData.sportId,
  //       competitionId: eventData.competitionId,
  //       eventId: eventData.eventId,
  //       marketType: 'BOOKMAKER',
  //       marketId: '-',
  //       sessionId: '-',
  //     };
  //     let response;
  //     if (sessionStorage.getItem('jwt_token')) {
  //       response = await API.post('/house/fetch-bet-limits', payload, {
  //         headers: {
  //           Authorization: sessionStorage.getItem('jwt_token'),
  //         },
  //       });
  //     } else {
  //       response = await API.post('/house/fetch-bet-limits', payload);
  //     }
  //     if (response.status === 200 && response.data.length !== 0) {
  //       const order = [
  //         'HOUSE',
  //         'CATEGORY',
  //         'SPORT',
  //         'COMPETITION',
  //         'EVENT',
  //         'MARKET',
  //         'SPORT_MARKET'
  //       ];
  //       const data = response.data;
  //       data.sort((a, b) => {
  //         const aDesc = a.betLimitsType;
  //         const bDesc = b.betLimitsType;
  //         if (order.indexOf(aDesc) > order.indexOf(bDesc)) {
  //           return -1;
  //         } else if (
  //           order.indexOf(aDesc) < order.indexOf(bDesc) ||
  //           order.indexOf(aDesc) === -1 ||
  //           order.indexOf(bDesc) === -1
  //         ) {
  //           return 1;
  //         } else {
  //           return -1;
  //         }
  //       });
  //       // Set gen min and max stakes
  //       const otherLimits = data.filter(
  //         (l) => l.betLimitsType !== 'MARKET' && !l.genId.includes('BOOKMAKER')
  //       );
  //       setMinStake(otherLimits[0].minStake);
  //       setMaxStake(otherLimits[0].maxStake);

  //       const sportLimits = data.filter(
  //         (l) => l.betLimitsType === 'SPORT_MARKET' && l.genId.includes('BOOKMAKER')
  //       );
  //       if (sportLimits.length > 0) {
  //         setMinStake(sportLimits[0].minStake);
  //         setMaxStake(sportLimits[0].maxStake);
  //       }
  //       // Set min and max limits by market
  //       const marketLimits = data.filter(
  //         (l) => l.betLimitsType === 'MARKET' && l.genId.includes('BOOKMAKER')
  //       );
  //       if (marketLimits.length > 0) {
  //         const limits: LimitsType = new Map();
  //         for (let ml of marketLimits) {
  //           const genIdParts = ml.genId.split(':');

  //           limits.set(genIdParts[genIdParts.length - 2], {
  //             minStake: ml.minStake,
  //             maxStake: ml.maxStake,
  //           });
  //         }
  //         setLimits(limits);
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const getBetLimits = (marketId: string, limit: 'min' | 'max') => {
    if (limits && limits.get('MI' + marketId)) {
      return limit === 'min'
        ? limits.get('MI' + marketId).minStake
        : limits.get('MI' + marketId).maxStake;
    } else {
      return limit === 'min' ? minStake : maxStake;
    }
  };

  const extractCommission = (str) => {
    const match = str.match(/(\d+)%Comm/);
    return match ? parseInt(match[1], 10) : null;
  };

  return (
    <>
      {bmMData.map((market, index) => (
        <div className="bm-table-ctn">
          <div className="bm-table-content table-ctn">
            <TableContainer component={Paper}>
              <Table className="bm-table">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={3}>
                      <div className="market-name-cell-head-ctn">
                      <span>
  {market.marketName
    ? market.marketName.toLowerCase().includes('over bookmaker')
      ? market.marketName.slice(0, 2) +
        ' ' +
        (langData?.[getMarketLangKeyByName('over bookmaker')] || 'Over Bookmaker') +
        market.marketName.slice(17)
      : market.marketName.toLowerCase().includes('over market')
      ? market.marketName.slice(0, 2) +
        ' ' +
        (langData?.[getMarketLangKeyByName('over market')] || 'Over Market') +
        market.marketName.slice(14)
      : market.marketName.toLowerCase().includes('bookmaker') &&
        market.marketName.toLowerCase().includes('%comm')
      ? (langData?.['bookmaker'] || 'Bookmaker') +
        ' ' +
        extractCommission(market.marketName) +
        ' %' +
        (langData?.['comm'] || 'Comm')
      : langData?.[getMarketLangKeyByName(market.marketName)] || market.marketName
    : 'N/A'}
    
  <IonIcon
    onClick={() =>
      setInfoDialog({
        launch: true,
        oddsType: 'Bookmaker',
        eventTypeID: eventData.sportId,
      })
    }
    className="info-img"
    src={InfoImg}
  />
  
  {market.commissionEnabled ? (
    <span className="blink-commission-bookmaker">*</span>
  ) : null}
</span>
                        {' '}
                        <span className='bet-limits-section'>
                        {langData?.['min']}:
                          {ThousandFormatter(
                            market?.marketLimits
                              ? market?.marketLimits.minStake / cFactor
                              : 100, "min"
                          )}{' '}
                        {langData?.['max']}:
                          {
                            market?.marketLimits?.maxStake % 1000 === 0 ?
                              ThousandFormatter(
                                market?.marketLimits
                                  ? market?.marketLimits.maxStake / cFactor
                                  : 5000, "max"
                              ) : market?.marketLimits
                                ? market?.marketLimits.maxStake / cFactor
                                : 5000
                          }
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow className="header-row">
                    {tableFields.map((tF, index) => (
                      <TableCell
                        key={tF.key + index}
                        align={tF.align === 'left' ? 'left' : 'center'}
                        className={tF.className}
                      >
                        {tF.key === 'lay' || 'back' ? (
                          <div className={tF.key.toLowerCase() + '-odd'}>
                            {langData?.[tF.Label.toLowerCase()]}
                          </div>
                        ) : (
                          langData?.[tF.Label.toLowerCase()]
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                  {market ? (
                    <>
                      {market.runners.map((bmSelection, index) => (
                        <TableRow>
                          <TableCell className="team-name-cell">
                            <div className="team">
                              {bmSelection.runnerName}
                              {getOpenBetsPLInArray(
                                      bmSelection,
                                      market.marketId,
                                      market.marketName
                                    ).map((ret) =>
                                      ret !== null ? (
                                        <span
                                          className={ret >= 0 ? 'profit' : 'loss'}
                                        >
                                          {ret > 0
                                            ? '+' + Number(ret).toFixed(2)
                                            : Number(ret).toFixed(2)}
                                        </span>
                                      ) : null
                                    )}
                            </div>
                            {bets.length > 0 && bets[0].amount > 0 ? (
                              <div>
                                {getTotalPL(
                                        bmSelection,
                                        market.marketId,
                                        market.marketName
                                      ).map((ret) =>
                                        ret !== null ? (
                                          <span
                                            className={
                                              ret >= 0 ? 'profit' : 'loss'
                                            }
                                          >
                                            {ret > 0
                                              ? '+' + Number(ret).toFixed(2)
                                              : Number(ret).toFixed(2)}
                                          </span>
                                        ) : null
                                      )}
                              </div>
                            ) : null}
                          </TableCell>
                          <TableCell className="odds-cell">
                            <div className="odds-block">
                            <ExchOddBtn
                                      mainValue={
                                        disabledStatus.includes(
                                          market.status?.toLowerCase()
                                        ) ||
                                          disabledStatus.includes(
                                            bmSelection.status?.toLowerCase()
                                          ) ||
                                            market.suspend === true
                                          ? 0
                                          : bmSelection.backPrice
                                      }
                                      subValue={Number(bmSelection.backSize)}
                                      oddType="back-odd"
                                      valueType="bookmakerOdds"
                                      showSubValueinKformat={true}
                                      disable={
                                        disabledStatus.includes(
                                          market.status?.toLowerCase()
                                        ) ||
                                        disabledStatus.includes(
                                          bmSelection.status?.toLowerCase()
                                        ) ||
                                          market.suspend === true
                                        ||
                                          moment(eventData.openDate).diff(
                                          moment(),
                                          'minutes'
                                        ) >
                                        60 * 24 * 2
                                      }
                                      onClick={() => {
                                        if (
                                          disabledStatus.includes(
                                            market.status?.toLowerCase()
                                          ) ||
                                          disabledStatus.includes(
                                            bmSelection.status?.toLowerCase()
                                          ) ||
                                            market.suspend === true
                                            ||
                                          moment(eventData.openDate).diff(
                                            moment(),
                                            'minutes'
                                          ) >
                                          60 * 24 * 2
                                        ) {
                                          return;
                                        }
                                        const betData: PlaceBetRequest = {
                                          sportId: eventData.sportId,
                                          seriesId: eventData.competitionId,
                                          seriesName: eventData.competitionName,
                                          eventId: eventData.eventId,
                                          eventName: eventData.eventName,
                                          eventDate: eventData.openDate,
                                          marketId: market.marketId,
                                          marketName: market.marketName,
                                          marketType: 'BM',
                                          outcomeId: bmSelection.runnerId,
                                          outcomeDesc: bmSelection.runnerName,
                                          betType: 'BACK',
                                          amount: 0,
                                          oddValue: Number(bmSelection.backPrice),
                                          sessionPrice: -1,
                                          oddLimt:
                                          market?.marketLimits?.maxOdd.toString(),
                                          minStake:
                                          market?.marketLimits?.minStake,
                                          maxStake:
                                          market?.marketLimits?.maxStake,
                                          mcategory: "ALL",
                                        };
                                        if (
                                          market.marketName.toUpperCase() ===
                                          'TOSS' &&
                                          Number(bmSelection.backPrice) > 0
                                        ) {
                                          betData['displayOddValue'] =
                                            TOSS_ODD_VALUE;
                                        }
                                        addExchangeBet(betData);
                                      }}
                                    />
                            </div>
                          </TableCell>
                          <TableCell className="odds-cell">
                            <div className="odds-block">
                            <ExchOddBtn
                                      mainValue={
                                        disabledStatus.includes(
                                          market.status?.toLowerCase()
                                        ) ||
                                          disabledStatus.includes(
                                            bmSelection.status?.toLowerCase()
                                          )
                                          ||
                                            market.suspend === true
                                          ? 0
                                          : bmSelection.layPrice
                                      }
                                      subValue={Number(bmSelection.laySize)}
                                      oddType="lay-odd"
                                      valueType="bookmakerOdds"
                                      showSubValueinKformat={true}
                                      disable={
                                        disabledStatus.includes(
                                          market.status?.toLowerCase()
                                        ) ||
                                        disabledStatus.includes(
                                          bmSelection.status?.toLowerCase()
                                        ) ||
                                            market.suspend === true
                                        ||
                                        moment(eventData.openDate).diff(
                                          moment(),
                                          'minutes'
                                        ) >
                                        60 * 24 * 2
                                      }
                                      onClick={() => {
                                        if (
                                          disabledStatus.includes(
                                            market.status?.toLowerCase()
                                          ) ||
                                          disabledStatus.includes(
                                            bmSelection.status?.toLowerCase()
                                          ) ||
                                          market.suspend === true
                                          ||
                                          moment(eventData.openDate).diff(
                                            moment(),
                                            'minutes'
                                          ) >
                                          60 * 24 * 2
                                        ) {
                                          return;
                                        }
                                        const betData: PlaceBetRequest = {
                                          sportId: eventData.sportId,
                                          seriesId: eventData.competitionId,
                                          seriesName: eventData.competitionName,
                                          eventId: eventData.eventId,
                                          eventName: eventData.eventName,
                                          eventDate: eventData.openDate,
                                          marketId: market.marketId,
                                          marketName: market.marketName,
                                          marketType: 'BM',
                                          outcomeId: bmSelection.runnerId,
                                          outcomeDesc: bmSelection.runnerName,
                                          betType: 'LAY',
                                          amount: 0,
                                          oddValue: Number(bmSelection.layPrice),
                                          sessionPrice: -1,
                                          oddLimt:
                                            market?.marketLimits?.maxOdd.toString(),
                                          minStake:
                                            market?.marketLimits?.minStake,
                                          maxStake:
                                            market?.marketLimits?.maxStake,
                                          mcategory: "ALL",
                                          };
                                        if (
                                          market.marketName.toUpperCase() ===
                                          'TOSS' &&
                                          Number(bmSelection.layPrice) > 0
                                        ) {
                                          betData['displayOddValue'] =
                                            TOSS_ODD_VALUE;
                                        }
                                        addExchangeBet(betData);
                                      }}
                                    />
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell colSpan={3}>
                          <div className="bm-table-msg-text">
                          {langData?.['bookmaker_markets_not_found_txt']}
                          </div>
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Modal
              open={infoDilalog.launch}
              closeHandler={() =>
                setInfoDialog({
                  launch: false,
                  oddsType: null,
                  eventTypeID: null,
                })
              }
              customClass="light-bg-title"
              title={langData?.['rules']}
              size="md"
            >
              <MarketTermsCondi
                oddsType={infoDilalog.oddsType}
                eventTypeID={infoDilalog.eventTypeID}
              />
            </Modal>
          </div>
        </div>
      ))}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  const event = state.exchangeSports.selectedEvent;

  return {
    // eventData: getAllMarketsByEvent(
    //   state.exchangeSports.events,
    //   eventType.id,
    //   competition.id,
    //   event.id
    // ),
    // bmMData: getBookmakerMarketsByEvent(
    //   state.exchangeSports.secondaryMarketsMap,
    //   event.id
    // ),
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    langData:state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BmMTable);
